function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 22.777h18.233V.16H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.14 19.91l2.948-.585 8.294-12.63a2.06 2.06 0 00.316-1.565 2.05 2.05 0 00-.885-1.318 2.085 2.085 0 00-1.154-.347 2.09 2.09 0 00-1.74.92L3.575 17.093l.566 2.817zm-1.042 2.87a1.329 1.329 0 01-1.304-1.06l-.933-4.64a1.3 1.3 0 01.19-.978L9.7 2.933A4.766 4.766 0 0113.664.827c.936 0 1.843.273 2.623.79a4.675 4.675 0 012.019 2.996 4.644 4.644 0 01-.705 3.534l-8.59 13.084a1.342 1.342 0 01-.854.573l-4.799.951a1.227 1.227 0 01-.26.026z",
  fill: "#16191C",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(.5 .335)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.43 16.824L11.7 4.23a1.753 1.753 0 011.458-.767 1.737 1.737 0 011.446 2.71l-8.22 12.52-2.482.491-.474-2.359zM13.163.16a5.098 5.098 0 00-4.24 2.25L.27 15.586c-.24.364-.323.8-.238 1.226l.934 4.638a1.66 1.66 0 001.958 1.296l4.798-.95a1.673 1.673 0 001.068-.718l8.594-13.086c1.55-2.306.92-5.443-1.41-6.986a5.074 5.074 0 00-2.81-.845zM7.396 20.175H7.4h-.004zm-4.018-.21l3.414-.676 8.37-12.748a2.397 2.397 0 00-.664-3.34 2.423 2.423 0 00-1.34-.404c-.782 0-1.55.376-2.017 1.069L2.719 16.689l.66 3.276zM13.164.825c.84 0 1.689.237 2.438.733a4.362 4.362 0 011.221 6.07L8.23 20.714a.996.996 0 01-.639.43l-4.799.95a1.139 1.139 0 01-.195.02.998.998 0 01-.975-.795L.69 16.68a.98.98 0 01.142-.732l8.65-13.169A4.43 4.43 0 0113.163.824z",
  fill: "#16191C",
  fillRule: "nonzero",
  mask: "url(#b)"
})));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default SvgComponent;